module.exports = __webpack_public_path__ + "static/media/ico_circle_checked.ee6f7a77.svg";